<template>
	<div>
		<el-dialog title="短信验证" :visible.sync="dialogVisible" width="540px" :before-close="handleClose">
			<div class="">
				<div>由于此人员在其它公司在职，为保证账号安全，入职新公司需进行短信验证</div>
				<div class="align-item mt20">
					<div class="mr10">短信验证</div>
					<el-input v-model.trim="smsValue" placeholder="请输入" @input="smsValue=smsValue.replace(/[^\d]/g,'')" maxlength="6" style="width: 150px;"></el-input>
					<div class="ml10 isBlue cur" v-if="!codeName">{{ codeName ? '获取验证码':time+'s'}}</div>
					<div class="ml10 isBlue cur" @click="addLoginCode" v-else>{{ codeName ? '获取验证码':time+'s'}}</div>
				</div>
			</div>
			<span slot="footer" class="dialog-footer">
				<el-button type="primary" @click="confirm">确 定</el-button>
			</span>
		</el-dialog>
	</div>
</template>

<script>
import { decrypt, encrypt } from '../../../assets/javascript/untils.js'
export default {
	data() {
		return {
			mobile: '',
			smsValue: '',
			codeName: true,
			time: 60,
			dialogVisible: false,
		}
	},
	methods: {
		open(arg) {
			this.mobile = arg.mobile || ''
			this.smsValue = ''
			this.dialogVisible = true
		},
		addLoginCode() {
			let arr = encrypt(
				JSON.stringify({
					mobile: this.mobile,
					bizType: 'registerVerify',
					millisecond: new Date().getTime(),
				})
			)
			this.$api.post(this.$url.send, arr).then((resp) => {
				if (resp) {
					this.codeName = false
					this.$message.success('短信发送成功')
				} else {
					this.codeName = true
					clearInterval(auth_timetimer)
				}
				this.time = 60
			})
			let auth_timetimer = setInterval(() => {
				if (this.time <= 0) {
					this.time = 60
					this.codeName = true
					clearInterval(auth_timetimer)
				}
				this.time--
			}, 1000)
		},
		async confirm() {
			if (!this.smsValue) return this.$message.error('请输入短信验证码')
			const res = await this.$api.post(this.$url.common.verify, { bizType: 'registerVerify', mobile: this.mobile, verifyCode: this.smsValue })
			if (res) {
				this.dialogVisible = false
				this.$emit('smsBack', true)
			}
		},
    handleClose () {
      this.dialogVisible = false
    },
	},
}
</script>

<style></style>
